// const callCenterConfigurationReports = [
//   {
//     icon: "calendar_view_week",
//     key: "queue.Time.Interval",
//     name: "Queue Time Interval",
//     url: "home/app/QueueTimeInterval",
//     productionReady: true,
//   },

//   {
//     icon: "analytics_icon  ",
//     key: "unAnswered",
//     name: "UnAnswered Report",
//     url: "home/app/Unanswered_Report",
//     productionReady: true,
//   },
//   // {
//   //   icon: "summarize",
//   //   key: "dispositionAnalysisQueue",
//   //   name: "DispositionAnalysisQueue",
//   //   url: "home/app/billing/DispositionAnalysisQueue",
//   //   productionReady: true,
//   // },
//   {
//     icon: "folder_copy",
//     key: "disposition.Analysis.Queue",
//     name: "Disposition-Analysis-Queue",
//     url: "home/app/configurations/disposition-analysis-queue",
//     description: "",
//     productionReady: true,
//     disabled: false,
//   },
//   {
//     icon: "article",
//     key: "answered",
//     name: "Answered Report",
//     url: "home/app/AnsweredReport",
//     productionReady: true,
//   },
//   {
//     icon: "article",
//     key: "last.Abandoned.Records",
//     name: "Last Abandoned Records",
//     url: "home/app/LastAbandonedRecords",
//     productionReady: true,
//   },
//   // {
//   //   icon: "calendar_view_week",
//   //   key: "group.abandoned.call",
//   //   name: "Group Abandoned Call",
//   //   url: "home/app/configurations/report/GroupAbandonedCall",
//   //   productionReady: true,
//   // },
//   {
//     icon: "article",
//     key: "agent.Call.DataAnalysis",
//     name: "Agent Call Data Analysis",
//     url: "home/app/AgentCallDataAnalysis",
//     productionReady: true,
//   },
//   {
//     icon: "article",
//     key: "caller.Call.DataAnalysis",
//     name: "Caller Call Data Analysis",
//     url: "home/app/CallerCallDataAnalysis",
//     productionReady: true,
//   },
//   {
//     icon: "summarize",
//     key: "agent.performance.Daily",
//     name: "Agent Performance Daily Report",
//     url: "home/app/billing/agent-performance",
//     productionReady: true,
//   },
//   {
//     icon: "assignment",
//     key: "agent.performance.summary",
//     name: "Agent Performance Summary Report",
//     url: "home/app/billing/agent-performance-summary",
//     productionReady: true,
//   },
//   {
//     icon: "summarize",
//     key: "queue.Performance.Daily",
//     name: "Queue-Performance Daily Report",
//     url: "home/app/configurations/report/queuePerformanceDailyReport",
//     productionReady: true,
//     disabled:true
//   },
//   {
//     icon: "article",
//     key: "queue.Performance.Summary",
//     name: "Queue-Performance-Summary Report",
//     url: "home/app/configurations/report/queuePerformanceSummary",
//     productionReady: true,
//     disabled: false,
//   },
//   {
//     icon: "calendar_view_week",
//     key: "user.login.logout",
//     name: "Agent-LogIn-LogOut",
//     url: "home/app/configurations/user-login-logout",
//     productionReady: true,
//   },
//   {
//     icon: "analytics_icon  ",
//     key: "campaign.Summary",
//     name: "Campaign Summary",
//     url: "home/app/campaignSummary",
//     productionReady: true,
//   },
//   {
//     icon: "article",
//     key: "callDisposition.Analysis.Campaign",
//     name: "Disposition Analysis-Campaign",
//     url: "home/app/callDisposition",
//     productionReady: true,
//   },
//   {
//     icon: "summarize",
//     key: "lead.Summary",
//     name: "Lead Summary",
//     url: "home/app/leadSummary",
//     productionReady: true,
//   },
//   // {
//   //   icon: "summarize",
//   //   key: "agent-DailyReport",
//   //   name: "Daily Report",
//   //   url: "home/app/billing/agent-dailyReport",
//   //   productionReady: true,
//   // },
//   {
//     icon: "summarize",
//     key: "skippedNumber",
//     name: "Skipped Number",
//     url: "home/app/skipped-Number",
//     productionReady: true,
//   },
//   {
//     icon: "summarize",
//     key: "call.Back",
//     name: "Call Back",
//     url: "home/app/call-Back",
//     productionReady: true,
//   },
//   {
//     icon: "summarize",
//     key: "blaster",
//     name: "Blaster Reports",
//     url: "home/app/Blaster-Reports",
//     productionReady: true,
//   },
//   {
//     icon: "summarize",
//     key: "feedBack",
//     name: "FeedBack Reports",
//     url: "home/app/feedBack-Reports",
//     productionReady: true,
//   },

// ];

// export { callCenterConfigurationReports };




import AuthenticationService from "application/modules/authentication/AuthenticationService";

export const getCallCenterConfigurationReports = () => {
  try {
    const menus = AuthenticationService.getGroupMenus();
    if (!menus || !Array.isArray(menus) || menus.length === 0) {
      console.warn("⚠️ No group menus found in session.");
      return [];
    }
    const reportGroupObj = menus.find((obj) => obj.callCenterReport);
    if (!reportGroupObj || !Array.isArray(reportGroupObj.callCenterReport)) {
      console.warn("⚠️ No 'callCenterReport' found in menu data.");
      return [];
    }
    const callCenterConfigurationReports = reportGroupObj.callCenterReport.map((item) => ({
      icon: item.icon || "article",
      key: item.key || "",
      name: item.menuName || item.name || "Untitled Report",
      url: item.url || "",
      productionReady: item.productionReady ?? true,
      disabled: item.isActive === false,
      description: item.description || "",
    }));

    return callCenterConfigurationReports;
  } catch (error) {
    console.error("❌ Error while fetching call center reports:", error);
    return [];
  }
};

// ✅ Export the dynamically generated list
export const callCenterConfigurationReports = getCallCenterConfigurationReports();
